import { useEffect } from 'react';

export function usePageTitle(title: string) {
  useEffect(() => {
    document.title = `${title} | Stéphane Mbangossoum`;
    return () => { document.title = 'Stéphane Mbangossoum'; };
  }, [title]);
}
